import axios from "axios";
import AWN from "awesome-notifications";
import "../../css/awesome-notifications/style.css";
import "../../js/awesome-notifications/index.var.js";

export default Object.assign({
    get: function(url) {
        return interceptor(axios.get(url));
    },
    post: function(url, model) {
        return interceptor(axios.post(url, model));
    }
})

function interceptor(promise) {
    return {
        then: function (successCallback) {
            promise.then(function (response) {
                successCallback(response);
            }).catch(function (error) {
                console.log(error);
                const notifier = new AWN({});
                notifier.alert("UH Oh.  Something broke.  \r\n Please try again or contact your Administrator");
            });
        }
    }
}